export default __webpack_public_path__ + "static/media/discount.c3a0f950.png";